import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { AppLoginModalContent } from './AppLoginModalContent';

export const AppLoginModal = () => {
  return (
    <AppModal
      modalName={Modals.APP_LOGIN_QR_CODE}
      scroll="body"
      transparentBackground>
      <AppLoginModalContent />
    </AppModal>
  );
};
